import React, { useEffect } from "react";
import styled from "styled-components";
import portfolio from "../content/portfolio.json";
import PageHelmet from "../components/PageHelmet";

const { meta, links } = portfolio;

const HeroContainer = styled.div`
    display: grid;
    grid-template-columns: 1fr 2fr; /* Image takes 1/3, text takes 2/3 */
    align-items: center;
    justify-content: center;
    height: 100vh;
    width: 100%; /* Full width */
    max-width: 1200px; /* Prevents excessive stretching on large screens */
    margin: 0 auto; /* Centers the container */
    padding: 20px;

    @media (max-width: 768px) {
        grid-template-columns: 1fr; /* Stack vertically on smaller screens */
        text-align: center;
    }
`;

const Leftcolumn = styled.div`
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const ProfileImage = styled.img`
    width: 500px;
    height: 500px;
    border-radius: 50%;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);

    @media (max-width: 768px) {
        width: 120px;
        height: 120px;
    }
`;

const RightColumn = styled.div`
    flex: 2;
    text-align: center;

    @media (max-width: 768px) {
        margin-top: 20px; /* Add spacing between sections on mobile */
    }
`;

const HeroTitle = styled.h1`
    font-size: 4rem;
    margin: 0;

    @media (max-width: 768px ) {
        font-size: 3rem;
    }
`;

const HeroSubtitle = styled.p`
    font-size: 1.5rem;
    margin: 10px 0;
`;

const ButtonContainer = styled.div`
    margin-top: 20px; /* Add spacing between subtitle and buttons */
    display: flex;
    flex-direction: column; /* Stack buttons vertically */
    align-items: center;
    gap: 10px; /* Spacing between buttons */
`;

const HeroButton = styled.a`
    padding: 10px 20px;
    color: #fff;
    background: #0078d7; /* Subtle blue for better contrast */
    text-decoration: none;
    border-radius: 5px;
    font-size: 1rem;
    text-align: center;
    width: 200px; /* Consistent width for all buttons */
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* Add a subtle shadow */
    transition: all 0.3s ease-in-out;

    &:hover {
        background: #005bb5; /* Slightly darker shade on hover */
        transform: translateY(-3px); /* Add a subtle "lift" effect */
        box-shadow: 0 6px 10px rgba(0, 0, 0, 0.2); /* Enhance the shadow */
    }
`;

const FooterContainer = styled.footer`
    margin-top: auto;
    text-align: center;
    padding: 20px 10px;
    font-size: 0.9rem;
    color: #666;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const SocialLinks = styled.div`
    display: flex;
    gap: 20px;
    margin-bottom: 10px;

    a {
        color: #0078d7;
        text-decoration: none;
        transition: color 0.3s;

        &:hover {
        color: #005bb5;
        }
    }
`;

const CopyRight = styled.div`
    font-size: 0.8rem;
    color: #999;
`;

const ElevenLabsWidget = () => {
    const [ready, setReady] = React.useState(false);

        useEffect(() => {
        // Prevent duplicate script injection
        if (!document.querySelector("#elevenlabs-script")) {
        const script = document.createElement("script");
        script.id = "elevenlabs-script";
        script.src = "https://unpkg.com/@elevenlabs/convai-widget-embed";
        script.async = true;
        script.type = "text/javascript";
        script.onload = () => {
            console.log("✅ ElevenLabs script loaded (only once)");
            setReady(true);
        };
        document.body.appendChild(script);
        } else {
        // Already loaded
        setReady(true);
        }
    }, []);

    if (!ready) return null;

    return (
        <elevenlabs-convai agent-id={meta.agentId}></elevenlabs-convai>
    );
};

const Home = () => {
    return (
        <>
        <PageHelmet title={meta.pageTitles.home} />
        <HeroContainer>
            <Leftcolumn>
                <ProfileImage src="/images/myphoto.jpg" alt={meta.name} />
            </Leftcolumn>
            <RightColumn>
                <HeroTitle>{meta.name}</HeroTitle>
                <HeroSubtitle>{meta.title}</HeroSubtitle>
                <ButtonContainer>
                    <HeroButton href={links.blog} target="_blank" rel="noopener noreferrer">My Blog</HeroButton>
                    <HeroButton href="/About">About me</HeroButton>
                    <HeroButton href="/Contact">Contact me</HeroButton>
                </ButtonContainer>
                <Footer />
                <ElevenLabsWidget /> {/* <-- Now safely loaded */}
            </RightColumn>
        </HeroContainer>

        {/* ElevenLabs Voice Agent Widget Scripts
        <elevenlabs-convai agent-id="agent_2701k37ncykhe48rpbdmrd64fw8d"></elevenlabs-convai><script src="https://unpkg.com/@elevenlabs/convai-widget-embed" async type="text/javascript"></script> */}
    </>

    );
};

const Footer = () => (
    <FooterContainer>
        <SocialLinks>
            <a href={links.linkedin} target="_blank" rel="noopener noreferrer">LinkedIn</a>
            <a href={links.github} target="_blank" rel="noopener noreferrer">GitHub</a>
            <a href={links.twitter} target="_blank" rel="noopener noreferrer">X</a>
        </SocialLinks>
        <CopyRight>&copy; {new Date().getFullYear()} {meta.name}. All rights reserved.</CopyRight>
    </FooterContainer>
);

export default Home;
